import DOMPurify from "dompurify";

export const sanitizeHtml = (value) => {
  return DOMPurify.sanitize(String(value || ""), {
    USE_PROFILES: { html: true },
  });
};
